// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"fce4f7c9","453":"fce4f7c9"}[chunkId] + ".chunk.css";
};